import { insert, move, pick, remove } from 'ramda';

export const SELECTED_LOCATIONS_DROPPABLE_ID = 'selectedLocations';
export const AVAILABLE_LOCATIONS_DROPPABLE_ID = 'availableLocations';

export const isLocationVisible = (location, filterString) => {
  if (!filterString) {
    return true;
  }

  return location.name.toLowerCase().includes(filterString.toLowerCase());
};

const moveWithinLocationsSection = (sectionLocations, setSectionLocations, fromIndex, toIndex) =>
  setSectionLocations(move(fromIndex, toIndex, sectionLocations));

const moveToSelectedLocations = ({
  selectedLocations,
  setSelectedLocations,
  availableLocations,
  setAvailableLocations,
  fromIndex,
  toIndex,
}) => {
  setSelectedLocations(insert(toIndex, availableLocations[fromIndex], selectedLocations));
  setAvailableLocations(remove(fromIndex, 1, availableLocations));
};

const moveFromSelectedLocations = ({
  selectedLocations,
  setSelectedLocations,
  availableLocations,
  setAvailableLocations,
  fromIndex,
  toIndex,
}) => {
  setAvailableLocations(insert(toIndex, selectedLocations[fromIndex], availableLocations));
  setSelectedLocations(remove(fromIndex, 1, selectedLocations));
};

export const handleSelectLocation = ({
    selectedLocations,
    setSelectedLocations,
    availableLocations,
    setAvailableLocations,
  },
  locationId,
) => (
  moveToSelectedLocations({
    selectedLocations,
    setSelectedLocations,
    availableLocations,
    setAvailableLocations,
    fromIndex: availableLocations.findIndex(location => location.id === locationId),
    toIndex: selectedLocations.length,
  })
);

export const handleDeselectLocation = ({
    selectedLocations,
    setSelectedLocations,
    availableLocations,
    setAvailableLocations,
  },
  locationId,
) => (
  moveFromSelectedLocations({
    selectedLocations,
    setSelectedLocations,
    availableLocations,
    setAvailableLocations,
    fromIndex: selectedLocations.findIndex(location => location.id === locationId),
    toIndex: availableLocations.length,
  })
);

export const handleLocationDrop = ({
    selectedLocations,
    setSelectedLocations,
    availableLocations,
    setAvailableLocations,
  },
  dropResult,
) => {
  if (!dropResult.destination) {
    return;
  }

  const fromIndex = dropResult.source.index;
  const toIndex = dropResult.destination.index;

  if (dropResult.source.droppableId === dropResult.destination.droppableId) {
    const sourceArray =
      dropResult.source.droppableId === SELECTED_LOCATIONS_DROPPABLE_ID ? selectedLocations : availableLocations;
    const setSourceArray =
      dropResult.source.droppableId === SELECTED_LOCATIONS_DROPPABLE_ID ? setSelectedLocations : setAvailableLocations;
    moveWithinLocationsSection(sourceArray, setSourceArray, fromIndex, toIndex);
    return;
  }

  if (dropResult.destination.droppableId === SELECTED_LOCATIONS_DROPPABLE_ID) {
    moveToSelectedLocations({
      selectedLocations,
      setSelectedLocations,
      availableLocations,
      setAvailableLocations,
      fromIndex,
      toIndex,
    });
    return;
  }

  moveFromSelectedLocations({
    selectedLocations,
    setSelectedLocations,
    availableLocations,
    setAvailableLocations,
    fromIndex,
    toIndex,
  });
};

export const handleSelectAll = ({
  selectedLocations,
  setSelectedLocations,
  availableLocations,
  setAvailableLocations,
  locationsFilter,
}) => {
  const newAvailable = [];
  const newSelected = [...selectedLocations];

  availableLocations.forEach((availableLocation) => {
    if (isLocationVisible(availableLocation, locationsFilter)) {
      newSelected.push(availableLocation);
    } else {
      newAvailable.push(availableLocation);
    }
  });

  setAvailableLocations(newAvailable);
  setSelectedLocations(newSelected);
};

export const handleDeselectAll = ({
  availableLocations,
  setAvailableLocations,
  selectedLocations,
  setSelectedLocations,
}) => {
  setAvailableLocations([...availableLocations, ...selectedLocations]);
  setSelectedLocations([]);
};

export const mapShopsToLocationOptions = shops => shops.map(shop => pick(['id', 'name'], shop));
